import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  requestStart as requestStartAction,
  setInputValue as setInputValueAction,
  resetInputValue as resetInputValueAction,
} from '../modules';

const NewsletterContainer = ({
  childComponent: ChildComponent,
  ...props
}) => (
  <ChildComponent
    {...props}
  />
);

const mapStateToProps = ({ newsletter, content }) => ({
  pending: R.prop('pending', newsletter),
  success: R.prop('success', newsletter),
  error: R.prop('error', newsletter),
  status: R.prop('status', newsletter),
  submitButtonText: R.path(['newsletter', 'submitButtonText'], content),
  placeholderMessage: R.path(['newsletter', 'placeholderMessage'], content),
  errorMessage: R.path(['newsletter', 'errorMessage'], content),
  successMessage: R.path(['newsletter', 'successMessage'], content),
  url: R.path(['newsletter', 'url'], content),
  data: R.path(['newsletter', 'data'], content),
  emailDataKey: R.path(['newsletter', 'emailDataKey'], content),
  value: R.prop('value')(newsletter),
  isKlaviyoEnabled: R.path(['newsletter', 'isKlaviyoEnabled'], content),
  klaviyoScriptUrl: R.path(['newsletter', 'klaviyoScriptUrl'], content),
  klaviyoContainerClass: R.path(['newsletter', 'klaviyoContainerClass'], content),
});

const mapDispatchToProps = dispatch => ({
  requestStart: email => dispatch(requestStartAction(email)),
  setInputValue: value => dispatch(setInputValueAction(value)),
  resetInputValue: value => dispatch(resetInputValueAction(value)),
});

NewsletterContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsletterContainer);
